import { createAction, createSlice } from "@reduxjs/toolkit";
import { COMMON_STATUS, languages } from "constants/constants";
import { RootState } from "store/store";
import {
	ServiceCategoryDetail,
	ServiceCategoryQuery,
	ServiceCategoryUpload,
} from "../types.d";

export interface ServiceCategoryState {
	serviceCategoryList: ServiceCategoryDetail[];
	serviceCategoryDetail: ServiceCategoryDetail;
	serviceCategoryTotal: number;
}

export const serviceCategoryDefault: ServiceCategoryDetail = {
	id: 0,
	name: "",
	order: 1,
	status: COMMON_STATUS.enabled.value,
	servicesCategoryTranslations: languages.map(el => ({
		name: "",
		description: "",
		key: el.key,
		image: null,
		language: el.key,
	})),
};

const initialState: ServiceCategoryState = {
	serviceCategoryList: [],
	serviceCategoryDetail: serviceCategoryDefault,
	serviceCategoryTotal: 0,
};

export const serviceCategorySlice = createSlice({
	name: "serviceCategory",
	initialState,
	reducers: {
		setListServiceCategory(state, action) {
			state.serviceCategoryList = action.payload.data;
		},
		setDetailServiceCategory(state, action) {
			state.serviceCategoryDetail = action.payload;
		},
		setTotalServiceCategory(state, action) {
			state.serviceCategoryTotal = action.payload.total;
		},
		changeStatusServiceCategory(state, action) {
			const { id, status } = action.payload;
			const index = state.serviceCategoryList.findIndex(item => item.id === id);
			state.serviceCategoryList[index].status = status;
		},
	},
});

export const {
	setListServiceCategory,
	setDetailServiceCategory,
	setTotalServiceCategory,
	changeStatusServiceCategory,
} = serviceCategorySlice.actions;

export const selectServiceCategoryList = (state: RootState) =>
	state.serviceCategory.serviceCategoryList;
export const selectServiceCategoryTotal = (state: RootState) =>
	state.serviceCategory.serviceCategoryTotal;
export const selectServiceCategoryDetail = (state: RootState) =>
	state.serviceCategory.serviceCategoryDetail;

export interface GetListServiceCategoryPayload {
	query: ServiceCategoryQuery;
	callback?: () => void;
}

export const getListServiceCategoryAsync = createAction(
	"serviceCategory/getListServiceCategory",
	(payload: GetListServiceCategoryPayload) => ({
		payload,
	}),
);

export interface GetDetailServiceCategoryAsyncPayload {
	id: number;
	callback: () => void;
}

export const getDetailServiceCategoryAsync = createAction(
	"serviceCategory/getDetailServiceCategory",
	(payload: GetDetailServiceCategoryAsyncPayload) => ({
		payload,
	}),
);

export interface CreateServiceCategoryAsyncPayload {
	data: ServiceCategoryUpload;
	callback: () => void;
}

export const createServiceCategoryAsync = createAction(
	"serviceCategory/createServiceCategory",
	(payload: CreateServiceCategoryAsyncPayload) => ({
		payload,
	}),
);

export interface UploadServiceCategoryAsyncPayload {
	id: number;
	data: ServiceCategoryUpload;
	callback?: () => void;
}

export const updateServiceCategoryAsync = createAction(
	"serviceCategory/updateServiceCategory",
	(payload: UploadServiceCategoryAsyncPayload) => ({
		payload,
	}),
);

export default serviceCategorySlice.reducer;
